export const pluralize = (word: string, quantity: number) => {
  return quantity > 1 ? word.concat('s') : word;
};

export function createObjectUrl(file: File): string {
  return URL.createObjectURL(file);
}
